export const CROSS_SELL_A2C_PRODUCTS_KEY = 'CROSS_SELL_A2C_PRODUCTS';
